import React from "react";
import {
  array,
  arrayOf,
  func,
  int,
  number,
  obj,
  shape,
  string
} from "prop-types";
import uuid from "uuid/v1";

import NeighborhoodWithCheckbox from "../NeighborhoodWithCheckbox";
import * as S from "./styled";

const BoroughNeighborhoods = ({
  borough,
  hoveredAreaId,
  levelTwoAreas,
  neighborhoods,
  onCheck,
  onHover,
  selectedAreaIds
}) => {
  const shouldIndent = level => {
    let indentLevel = 3;
    if (borough === "Manhattan") {
      indentLevel = 4;
    }
    return level >= indentLevel;
  };

  const childRows = (area, allLevelTwoAreas) => {
    const areaCheckbox = (
      <NeighborhoodWithCheckbox
        key={area.id}
        isChecked={selectedAreaIds.includes(area.id)}
        isHovered={area.id === hoveredAreaId}
        isTitle={borough === "Manhattan" && area.level === 2}
        neighborhood={area}
        onCheck={onCheck}
        onHover={onHover}
        shouldIndent={shouldIndent(area.level)}
        showCheckBox
      />
    );

    const children = allLevelTwoAreas
      .filter(a => a.parent_id === area.id)
      .sort((a, b) => (a.name > b.name ? 1 : -1))
      .map(child => childRows(child, allLevelTwoAreas));

    return [areaCheckbox, children];
  };

  const renderNeighborhoods = () => {
    const areas = neighborhoods;
    if (borough !== "Manhattan") {
      areas.sort((a, b) => (a.name > b.name ? 1 : -1));
    }
    return areas.map(nabe => childRows(nabe, levelTwoAreas));
  };

  const chunk = (arrayToChunk, size) => {
    const chunked_arr = [];
    const numOfChildren = Math.ceil(arrayToChunk.length / size);
    for (let i = 0; i < numOfChildren; i += 1) {
      chunked_arr.push(arrayToChunk.splice(0, size));
    }
    return chunked_arr;
  };

  const renderColumns = () => {
    const allNeighborhoods = renderNeighborhoods();
    if (borough === "Manhattan") {
      return (
        <>
          <S.BoroughNeighborhoodsColumn>
            {allNeighborhoods[0]}
          </S.BoroughNeighborhoodsColumn>
          <S.BoroughNeighborhoodsColumn>
            {allNeighborhoods[1]}
            {allNeighborhoods[5]}
          </S.BoroughNeighborhoodsColumn>
          <S.BoroughNeighborhoodsColumn>
            {allNeighborhoods[2]}
            {allNeighborhoods[3]}
            {allNeighborhoods[4]}
          </S.BoroughNeighborhoodsColumn>
        </>
      );
    }
    const numberPerColumn = Math.ceil(allNeighborhoods.length / 3);
    return chunk(allNeighborhoods, numberPerColumn).map(column => (
      <S.BoroughNeighborhoodsColumn key={`neighborhood-column-${uuid()}`}>
        {column}
      </S.BoroughNeighborhoodsColumn>
    ));
  };

  return <S.BoroughNeighborhoods>{renderColumns()}</S.BoroughNeighborhoods>;
};

BoroughNeighborhoods.propTypes = {
  borough: string.isRequired,
  hoveredAreaId: number,
  levelTwoAreas: arrayOf(
    shape({
      decodedCoordinates: array,
      id: number,
      level: number,
      map_coordinates: obj,
      name: string,
      parent_id: int
    })
  ).isRequired,
  neighborhoods: arrayOf(
    shape({
      decodedCoordinates: array,
      id: number,
      level: number,
      map_coordinates: obj,
      name: string,
      parent_id: int
    })
  ).isRequired,
  onCheck: func.isRequired,
  onHover: func.isRequired,
  selectedAreaIds: arrayOf(number).isRequired
};

BoroughNeighborhoods.defaultProps = {
  hoveredAreaId: null
};

export default BoroughNeighborhoods;
